import React, { useContext, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './add_to_folder_add_button.module.scss';
import { FoldersDropdownContext } from '../FoldersDropdownContext';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useUser } from '../../../user/useUser';

export const AddToFolderAddButton: FC = () => {
  const { openDropdown } = useContext(FoldersDropdownContext);
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  return (
    <button
      type="button"
      id="add-to-folders"
      className={styles.button}
      onClick={
        accessPremium
          ? openDropdown
          : () => openRestrictedModal({ source: 'dropdown-folder' })
      }
    >
      <FormattedMessage id="folders/dropdown/AddToFolderAddButton.tsx/1" />
    </button>
  );
};
